import { mediaTypeSpm } from '@/spm/mediaTypeSpm';

export default [{
  path: '/manage/:media',
  name: 'manage',
  component: () => import(/* webpackChunkName: "windowManage" */'@/pages/manage/index'),
  meta: {
    pageId: 10002,
    spm: mediaTypeSpm,
    commonParams: ['media_type', 'media_id'],
  },
}];
